import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import PropTypes from 'prop-types';
import TableRow from './TableRow';
import TableHeaderRow from './TableHeaderRow';
import { useClassNames } from '../utils';
var Table = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$as = props.as,
      Component = _props$as === void 0 ? 'div' : _props$as,
      className = props.className,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'calendar-table' : _props$classPrefix,
      _props$rows = props.rows,
      rows = _props$rows === void 0 ? [] : _props$rows,
      rest = _objectWithoutPropertiesLoose(props, ["as", "className", "classPrefix", "rows"]);

  var _useClassNames = useClassNames(classPrefix),
      merge = _useClassNames.merge,
      withClassPrefix = _useClassNames.withClassPrefix;

  var classes = merge(className, withClassPrefix());
  return /*#__PURE__*/React.createElement(Component, _extends({
    role: "grid"
  }, rest, {
    ref: ref,
    className: classes
  }), /*#__PURE__*/React.createElement(TableHeaderRow, null), rows.map(function (week, index) {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: index,
      weekendDate: week
    });
  }));
});
Table.displayName = 'CalendarTable';
Table.propTypes = {
  rows: PropTypes.array,
  className: PropTypes.string,
  classPrefix: PropTypes.string
};
export default Table;